import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './InfrastructureLoader.css';

export const InfrastructureLoader: React.FC = () => {
  return (
    <div className={styles['wrapper']}>
      <Spinner size={40} />
    </div>
  );
};
